import { injectContextArray } from "@components/constructor";
import { PaginationProps } from "@constructor/components/core/pagination";
import {useCumulativeBonus, useDonateBonuses} from "@hooks/selectors/user/payments.selectors";
import {EPaymentBonusType, EThresholdType, IDonateBonus} from "@interfaces/user/payments";
import {FC, PropsWithChildren, useMemo} from "react";
import { DonateBonusProvider } from "./context";
import {InjectContextType} from "@interfaces/constructor/constructor";

interface DonateBonusListProps {
    bonus_type?: EPaymentBonusType;
    bonus_threshold_type?: EThresholdType;
}

interface DonateBonusListChildProps {
    donate_bonus_index: number;
    donate_bonus_active: boolean;
}

const DonateBonusList: FC<PropsWithChildren<DonateBonusListProps & PaginationProps>> = (
    {
        bonus_type,
        bonus_threshold_type,
        pagination_current_page = 0,
        pagination_per_page = 10,
        children
    }) => {

    const cumulative = useCumulativeBonus();
    const bonuses = useDonateBonuses().filter(x =>
        (bonus_type === undefined || x.type === bonus_type)
        && (bonus_threshold_type === undefined || x.thresholdType === bonus_threshold_type)
    );
    const page = bonuses.slice(pagination_current_page * pagination_per_page, (pagination_current_page + 1) * pagination_per_page);

    const data = useMemo<InjectContextType<IDonateBonus, DonateBonusListChildProps>[]>(() =>
        page.map((bonus, idx) => ({
            key: bonus.id,
            value: bonus,
            childData: {
                donate_bonus_index: pagination_current_page * pagination_per_page + 1 + idx,
                donate_bonus_active: bonus.id === cumulative?.id
            }
        })), [page, pagination_current_page, pagination_per_page, cumulative?.id]);

    return injectContextArray(data, DonateBonusProvider, children);
}

export default DonateBonusList;